import { Button } from "newui/components/Button";
import { LoginPath } from "../constants/TokenReferralConstants"
import { useReferralToken } from "newui/features/Auth/hooks/useReferralToken";
import { Box } from "@chakra-ui/react";

interface LoginPathButtonProps {
	loginPath: LoginPath;
	showReferralText?: boolean;
}

/**
 * Controls the referral link login to create account navigation
 * @param param0 
 * @returns 
 */
export const LoginPathButton: React.FC<LoginPathButtonProps> = ({ loginPath, showReferralText = false }) => {

	const { referralToken, setLoginPathChosen } = useReferralToken();

	if (!referralToken) {
		return null;
	}

	const buttonType = showReferralText ? "secondary" : loginPath === LoginPath.Login ? "primary" : "secondary";
	const buttonText = loginPath === LoginPath.Login ? "I have an account - Go to Login" : "I need to create an account";
	const referralText = loginPath === LoginPath.CreateAccount ? "You have a referral code, so you can create an account if you need to." : "Already have an account?";

	const onClick = () => {
		setLoginPathChosen(loginPath);
	}

	return (
		<Box paddingTop={showReferralText && "4"} width={"full"} gap={4} display="flex" flexDirection="column">
			{showReferralText && <p className="text-sm">{referralText}</p>}
			<Button type="button" btntype={buttonType} onClick={onClick} width={"full"}>{buttonText}</Button>
		</Box>
	);
}